import uniqueId from "lodash/uniqueId";

export const generateId = () => parseInt(uniqueId(), 10);

export default generateId;
